import { Disclosure } from '@headlessui/react';
import clsx from 'clsx';
import React from 'react';
import { IoTriangle } from 'react-icons/io5';

import RichText from '@/components/Primitive/RichText/RichText';
import Serialize from '@/utils/serializer';

interface FaqProps {
  question: string;
  answer: string;
  defaultOpen?: boolean;
}

const Faq = ({ question, answer, defaultOpen = false }: FaqProps) => {
  if (!question || !answer) return null;

  return (
    <div className="relative pb-8 after:absolute after:bottom-0 after:left-[-5%] after:w-[110%] after:border-b after:border-cream">
      <Disclosure as="div" defaultOpen={defaultOpen}>
        {({ open }) => (
          <>
            <Disclosure.Button className="mb-3 flex w-full items-center justify-between space-x-3 pt-10 text-left">
              <div className="text-xl font-black text-cream md:text-2xl">
                {question}
              </div>
              <IoTriangle
                className={clsx(
                  'h-4 w-4 shrink-0 text-cream transition-transform duration-300',
                  open ? 'rotate-180' : 'rotate-90'
                )}
              />
            </Disclosure.Button>
            <Disclosure.Panel className="text-gray-500">
              <RichText>{Serialize(answer)}</RichText>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
};

export default Faq;
